export const headerProps = () => ({
  magasin: {
    type: Object,
    required: false,
    default: null
  },
  modesCommande: {
    type: Array,
    required: false,
    default: () => []
  },
  montantTotalTTC: {
    type: [String, Number],
    required: true
  },
  storeId: {
    type: Number,
    required: false,
    default: null
  },
  customer: {
    type: Object,
    default: null
  },
  shopName: {
    type: String,
    default: null
  },
  shopPageLink: {
    type: String,
    required: false,
    default: ""
  },
  shopId: {
    type: [String, Number],
    default: null
  },
  isNational: {
    type: Boolean,
    default: true
  },
  shopCity: {
    type: String,
    required: false,
    default: null
  },
  shopPhone: {
    type: String,
    required: false,
    default: null
  },
  shopZipCode: {
    type: String,
    required: false,
    default: null
  },
  shopAddress: {
    type: String,
    required: false,
    default: null
  },
  shopfirstSlotAvailable: {
    type: String,
    required: false,
    default: null
  },
  headerPushZones: {
    type: Array,
    required: false,
    default: () => []
  },
  encartPanierVisible: {
    type: Boolean,
    required: true
  },
  isPanierLoading: {
    type: Boolean,
    required: false,
    default: false
  },
  showFindShop: {
    type: Boolean,
    required: false,
    default: false
  },
  isMenuShown: {
    type: Boolean,
    required: false,
    default: false
  },
  fidelites: {
    type: Array,
    required: false,
    default: () => []
  },
  isPro: {
    type: Boolean,
    required: false,
    default: false
  },
  showProHeader: {
    type: Boolean,
    required: false,
    default: false
  }
});

export const headerEmits = () => ([
  "shown",
  "hidden",
  "logout",
  "leaveProMode"
]);

export const useHeader = (props, emit, headerRef, popinEncartPanierRef, confirmClearRef) => {

  const route = useRoute();
  const router = useRouter();

  const isSticky = ref(false);
  const menuIsOpened = ref(!isSticky.value);
  const typePanierToDelete = ref(null);

  const isHomePage = computed(() => {
    return route.name === 'index';
  })
  const defaultHeaderMerchHtmlContent = computed(() => {
    if (props.headerPushZones) {
      const pushZone = props.headerPushZones.find(
        zone => props.isPro ? zone.code === "Header_Fil_Pro" : zone.code === "Header_Fil"
      );

      if (pushZone) {
        return pushZone;
      }
    }
    return null;
  })
  const mobileHeaderMerchHtmlContent = computed(() => {
    if (props.headerPushZones) {
      const pushZone = props.headerPushZones.find(
        zone => props.isPro ? zone.code === "Mobile_Header_Fil_Pro" : zone.code === "Mobile_Header_Fil"
      );
      if (pushZone) {
        return pushZone;
      }
    }
    return null;
  })

  const isMagasinOpen = computed(() => {
    if (props.magasin) {
      return isMagasinOpened(props.magasin);
    }
    return false;
  })

  const miamPushZone = computed(() => {
    let pushZone = {}
    if (props.headerPushZones) {
      pushZone = props.headerPushZones.filter(zone => zone.code === "Header_Recettes")
      if (pushZone) {
        return pushZone;
      } else {
        return [];
      }
    }
    return {};
  })

  const recettesPushZone = computed(() => {
    if (props.headerPushZones) {
      const pushZone = props.headerPushZones.find(
        zone => zone.code === "Header_Menu_Recettes"
      );
      if (pushZone) {
        return pushZone.form_content ? pushZone.form_content : pushZone;
      }
    }
    return null;
  })

  const changeShop = (idMagasin) => {
    router.replace('/?magasin_id=' + idMagasin);
  };
  const openMenu = () => {
    if (props.isMenuShown) {
      emit("shown");
    } else {
      emit("hidden");
    }
    menuIsOpened.value = !menuIsOpened.value;
  };
  const logout = () => {
    menuIsOpened.value = false
    emit("logout")
  };
  const hideEncartPanier = () => {
    if (popinEncartPanierRef) {
      popinEncartPanierRef.value.hide();
    }
  };
  const handleScroll = () => {
    if (headerRef && headerRef.value) {
      const scrollY = Math.round(window.scrollY);
      const headerHeight = headerRef.value.offsetHeight;
      if (scrollY > headerHeight) {
        document.body.classList.add("page-has-sticky-header");
        isSticky.value = true;
      } else {
        isSticky.value = false;
        document.body.classList.remove("page-has-sticky-header");
      }
    }
  };
  const showPopinViderPanier = (typePanier) => {
    typePanierToDelete.value = typePanier;
    if (confirmClearRef) {
      confirmClearRef.value.show()
    }
  };
  const mounted = () => {
    window.addEventListener("scroll", handleScroll);
  };
  const beforeUnmount = () => {
    window.removeEventListener("scroll", handleScroll);
  };

  return {
    isSticky,
    menuIsOpened,
    typePanierToDelete,
    isHomePage,
    defaultHeaderMerchHtmlContent,
    mobileHeaderMerchHtmlContent,
    isMagasinOpen,
    miamPushZone,
    recettesPushZone,
    changeShop,
    openMenu,
    logout,
    hideEncartPanier,
    handleScroll,
    showPopinViderPanier,
    mounted,
    beforeUnmount
  }
};